import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import Firebase, { withFirebase } from '../Firebase';
import * as ROUTES from '../../util/constants/routes';
import AuthUserContext from './context';

interface Props {
    firebase: Firebase,
    history: any
}

interface State {
    
}

const withAuthorization = (condition: any) => (Component: any) => {
    class WithAuthorization extends React.Component<Props, State>{
        listener: any;
        constructor(props:any) {
            super(props)
            this.state = {}
        }
        
        componentDidMount(){
            this.listener = this.props.firebase.onAuthUserListener(
                (authUser: any) => {
                    //QUESTION: what is this condition thing? 
                    //Is it a JS function? Some embedded thing? Is it simply just a local function?
                    if(!condition(authUser)) {
                        this.props.history.push(ROUTES.SIGN_IN);
                    }
                },
                () => this.props.history.push(ROUTES.SIGN_IN)
            );
        }

        componentWillUnmount() {
            //QUESTION: What does this do exactly? Why is it listed as a function? How does it turn off the listener?
            this.listener();
        }
        
        render() {
            return (
                <AuthUserContext.Consumer>
                    {(authUser: any) => 
                        condition(authUser) ? <Component {...this.props} /> : null  
                }
                </AuthUserContext.Consumer>
            );
        }
    }
    return compose(
        withRouter,
        withFirebase
    )(WithAuthorization);
}

export default withAuthorization;